if (!customElements.get('home-key-metrics')) {
  class HomeKeyMetrics extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this._observed = new Set();
      this._timers = [];
      this._reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this._initCounters();
      this._initTimelines();
      this._initBars();
    }

    disconnectedCallback() {
      if (this._io) {
        this._io.disconnect();
        this._io = null;
      }
      this._timers.forEach((id) => clearInterval(id));
      this._timers = [];
    }

    _initCounters() {
      const counters = this.querySelectorAll('[data-home-km-counter]');
      if (!counters.length) return;

      if (this._reduceMotion) {
        counters.forEach((el) => {
          const target = parseInt(el.getAttribute('data-target'), 10) || 0;
          const suffix = el.getAttribute('data-suffix') || '';
          el.textContent = `${target}${suffix}`;
        });
        return;
      }

      const animate = (el) => {
        const target = parseInt(el.getAttribute('data-target'), 10) || 0;
        const suffix = el.getAttribute('data-suffix') || '';
        const duration = 1500;
        let start_time = null;

        const step = (ts) => {
          if (!start_time) start_time = ts;
          const progress = Math.min((ts - start_time) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = `${Math.round(eased * target)}${suffix}`;
          if (progress < 1) requestAnimationFrame(step);
        };

        requestAnimationFrame(step);
      };

      this._io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || this._observed.has(entry.target)) return;
            this._observed.add(entry.target);
            animate(entry.target);
          });
        },
        { threshold: 0.5 }
      );

      counters.forEach((el) => this._io.observe(el));
    }

    _initTimelines() {
      const timelines = this.querySelectorAll('[data-home-km-timeline]');
      timelines.forEach((timeline) => {
        const steps = timeline.querySelectorAll('[data-home-km-step]');
        if (!steps.length) return;

        let idx = 0;
        steps[idx].classList.add('is-active');

        if (this._reduceMotion) return;

        const timer = setInterval(() => {
          steps[idx].classList.remove('is-active');
          idx = (idx + 1) % steps.length;
          steps[idx].classList.add('is-active');
        }, 1500);

        this._timers.push(timer);
      });
    }

    _initBars() {
      const tracks = this.querySelectorAll('[data-home-km-bars]');
      if (!tracks.length || this._reduceMotion) return;

      tracks.forEach((track) => {
        const bars = [...track.querySelectorAll('.home-km__bar')];
        if (!bars.length) return;

        let lit_count = 0;

        const tick = () => {
          if (lit_count >= bars.length) {
            bars.forEach((bar) => bar.classList.remove('is-lit'));
            lit_count = 0;
          }

          bars[lit_count].classList.add('is-lit');
          lit_count += 1;
        };

        tick();
        const timer = setInterval(tick, 80);
        this._timers.push(timer);
      });
    }
  }

  customElements.define('home-key-metrics', HomeKeyMetrics);
}
